import React from "react";
import DelegateModal from "design/components/popups/DelegateModal";
import useDelegateUsers from "backend/hooks/workflows/useDelegateUsers";
import useSubmitDelegateTask from "backend/hooks/workflows/useSubmitDelegateTask";
import { ICardElementWithChildren } from "backend/model/model";
const DelegateModalPopup = (props: {
  elem?: ICardElementWithChildren;
  onClose: () => void;
  isOpen?: boolean;
}) => {
  const { data: delegateUsers, isLoading: isLoadingDelegateUsers } =
    useDelegateUsers(props.elem?.workflowState?.wfInstanceId || "");

  const { mutate } = useSubmitDelegateTask();
  return (
    <DelegateModal
      users={delegateUsers || []}
      open={!!props.isOpen}
      onClose={props.onClose}
      onSubmit={(values) => {
        console.log("Delegate values", values);

        const userId = values.find((v) => v.field.fieldName === "user")?.value;
        const message = values.find(
          (v) => v.field.fieldName === "message"
        )?.value;

        if (typeof userId === "string" && typeof message === "string") {
          mutate({
            wfInstanceId: props.elem?.workflowState?.wfInstanceId || "",
            userId,
            message,
          });
          props.onClose();
        }
      }}
      title="Delegate"
      buttonText="Delegate"
      fields={[
        {
          type: "info",
          title: props.elem?.typename || "",
          content: (
            <div>
              {props.elem?.name} ({props.elem?.workflowState?.period || ""})
            </div>
          ),
        },
        {
          title: "Users",
          type: "select",
          fieldName: "user",
          values:
            delegateUsers?.map((usr) => ({
              id: usr.userId,
              title: usr.fullname,
            })) || [],
        },
        {
          title: "Message",
          type: "textarea",
          fieldName: "message",
        },
      ]}
    ></DelegateModal>
  );
};

export default DelegateModalPopup;
